import React from "react";
import InstituteFeesView from "@/pages/public/_shared/InstituteFeesView";
import { useRoe } from "./RoeLayout";

export default function RoeFees() {
  const data = useRoe() || {};
  const instId = data?.institute?.id || "";
  return (
    <div data-testid="roe-fees">
      <div className="bg-gradient-to-r from-emerald-800 via-emerald-700 to-teal-800 text-white">
        <div className="max-w-6xl mx-auto px-5 py-10">
          <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-amber-300">Know Your Fees</div>
          <h1 className="font-serif text-3xl sm:text-4xl mt-2">Fee Structure</h1>
          <p className="mt-2 text-white/80 text-sm max-w-2xl">Transparent, category-wise fee tables. Data is published and maintained by the Trust admin office.</p>
        </div>
      </div>
      <InstituteFeesView instituteId={instId} testidPrefix="roe-fees" />
    </div>
  );
}
